import { Component, Input, ViewChild, AfterViewInit, ElementRef, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Globals } from 'app/services/globals';
import { StorageService } from 'app/services/storage.service';
import { StorageTypeEnum, AbstractPickedFile, LocalPickedFile, CloudPickedFile, TemplatePickedFile } from 'app/models/picked-file';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { SelectionType } from "@swimlane/ngx-datatable";
import { Subject } from 'rxjs';
import { FileExplorerService } from 'app/services/file-explorer.service';
import { MyFile } from 'app/models/my-file';
import { FilePath } from 'app/models/file-path';
import { ToastService } from "ng-uikit-pro-standard";
import { FormTemplateService } from 'app/services/form-template.service';
import { FormTemplate, FormTemplateType } from 'app/models/template';
import { filter, map } from 'rxjs/operators';
import { Storage } from 'app/models/storage';

@Component({
  selector: 'app-files-folders-picker',
  templateUrl: './files-folders-picker.component.html',
  styleUrls: ['./files-folders-picker.component.scss']
})
export class FilesFoldersPickerComponent implements AfterViewInit {

  // Storage List Model
  //List of selected storage file and folder
  @ViewChild('storgeFileModel') storgeFileModel: ModalDirective;

  @ViewChild('fileInput') fileInput: ElementRef;

  //Incase True :- allow to select folder only
  //Incase false :- allow to select file only
  @Input() public isFolderSelector: boolean = false;
  //Incase True :- allow to select more than one file 
  //Incase false :- allow to select one file only
  @Input() public allowMultipleSelection: boolean = true;
  //Incase True :- Add the local computer option to storage list 
  @Input() public allowMyComputer: boolean = true;
  //Incase True :- Add the Templates option to storage list 
  @Input() public allowTemplates: boolean = true;
  //Incase True :- Add the Strorage option to storage list 
  @Input() public allowStorage: boolean = true;

  @Input() public cloudStorageFitlerCallback: (s: Storage[]) => Storage[] = null;

  @Output() picked: EventEmitter<AbstractPickedFile[]> = new EventEmitter<AbstractPickedFile[]>();
  @Output() close: EventEmitter<any> = new EventEmitter<any>();

  // IN case File Only this input to select the allowed type should be selected 
  @Input() set fileExtension(fileExtension: string[])  {

    this._fileExtension = fileExtension;
    if (!this.isFolderSelector && this.fileExtension.length > 0) {
      this.allowedExtension = "";
      this.fileExtension.forEach(element => {
        this.allowedExtension += "." + element + ", "
      });
    }
  }
  get fileExtension(): string[] {
    return this._fileExtension;
  }
  public outputFiles: Subject<AbstractPickedFile[]> = new Subject();
  public storageList: any[] = [];
  public selectionType = SelectionType.single;
  public filesLoadingIndicator: boolean = true;
  public files: MyFile[] = [];
  public selectedRows: MyFile[] = [];
  public selectedStorage: number = 0;
  public selectedStorageName: string = '';
  public currentPath: FilePath[] = [];
  //Incase True :- Second sreen 
  //Incase false :- first screen 
  public isFilesMode: boolean = false;

  private outputList: AbstractPickedFile[] = [];

  public allowedExtension: string = "*";
  _fileExtension: string[]=[];

  constructor(private storageService: StorageService, private fileService: FileExplorerService,
    private http: HttpClient, private globals: Globals, private toastService: ToastService,
    private formTemplateService: FormTemplateService) {
  }

  ngAfterViewInit() {
    //this.show();
  }

  innerWidth() {
    return window.innerWidth;
  }

  perpareStorageData() {
    this.storageList = [];
    this.isFilesMode = false;

    if (this.allowMyComputer) {
      this.storageList.push(this.mapStorageDataToFile("My Computer", StorageTypeEnum.LOCAL));
    }

    if (this.allowTemplates) {
      this.storageList.push(this.mapStorageDataToFile("Templates", StorageTypeEnum.TEMPLATES));
      if (!this.allowMyComputer && !this.allowStorage) {
        // Open the templates storage automatically, it's the only one there
        this.files = [];
        if (this.allowMultipleSelection)
          this.selectionType = SelectionType.multiClick;
        this.isFilesMode = true;
        this.selectedRows = []
        this.selectedStorage = 0;
        this.selectedStorageName = 'Templates';
        this.getAllFormTemplates();
        return;
      }
    }
    if (this.allowStorage) {
      this.storageService.getAll().pipe(map((s) => {
        return this.cloudStorageFitlerCallback? this.cloudStorageFitlerCallback(s): s;
      })).subscribe(storages => {

        storages.forEach(element => {
          this.storageList.push(this.mapStorageDataToFile(element.display_name, StorageTypeEnum.STORAGE, element.id))
        });
        this.files = this.storageList;
        this.filesLoadingIndicator = false;
      },
        err => {
          this.toastService.error("There is something wrong");
          this.filesLoadingIndicator = false;
        });
    }
    else {
      this.files = this.storageList;
      this.filesLoadingIndicator = false;
    }
  }

  backToStorageModel() {
    if (this.currentPath.length == 0) {
      this.files = this.storageList;
      this.isFilesMode = false;
      this.selectionType = SelectionType.single;
      this.selectedStorage = 0;
    }
    else {
      this.currentPath.pop();
      if (this.selectedStorage > 0)
        this.getAllFileStorage();
      else
        this.getAllFormTemplates();
    }
  }

  show() {
    this.outputList = [];
    this.currentPath = [];
    this.files = [];
    
    if (this.allowMyComputer && !this.allowTemplates && !this.allowStorage) {
      // open local file browser
      const uploader = this.fileInput.nativeElement as HTMLElement;
      uploader.click();
      this.selectedRows = [];
      return;
    }

    this.perpareStorageData();
    this.storgeFileModel.show();
  }

  hide() {
    if (this.storgeFileModel.isShown)
      this.storgeFileModel.hide();
    this.close.emit();
  }

  cancel() {
    this.hide();
  }

  mapStorageDataToFile(name: string, type: StorageTypeEnum, id?: number): MyFile {
    return {
      storageId: id,
      filename: name,
      extension: type,
      type: type,
      size: 0,
      basename: "",
      dirname: "",
      formatted_size: "",
      icon: "",
      path: "",
      timestamp: 0
    };
  }

  //#region  Local Region
  filesPicked(files: File[]) {

    files.forEach(element => {
      let file: LocalPickedFile = {
        storageType: StorageTypeEnum.LOCAL,
        isFolder: this.isFolderSelector,
        file: element
      }
      this.outputList.push(file);
    });
    this.outputFiles.next(this.outputList);
    this.picked.emit([...this.outputList]);
    this.outputList = [];
    this.fileInput.nativeElement.value = "";
    this.hide();
  }


  //#endregion

  onSelect({ selected }) {
    if (this.selectionType == SelectionType.single && selected.length > 0) {
      this.selectedRows = selected.slice(-1);
    }
  }

  //#region Storage Region
  getAllFileStorage() {
    this.filesLoadingIndicator = true;
    let lastDir = '';
    if (this.currentPath.length != 0) {
      lastDir = this.currentPath[this.currentPath.length - 1].path;
    }

    this.fileService.getAll("/" + lastDir, this.selectedStorage).subscribe((response: MyFile[]) => {
      if (!this.isFolderSelector) {
        if (this._fileExtension && this._fileExtension.length > 0) {
          this.files = [];
          this._fileExtension = this._fileExtension.map(function (x) { return x.toLowerCase() })
          response.filter(file => file.type != 'Folder').forEach(element => {
            if (this._fileExtension.indexOf(element.extension.toLowerCase()) >= 0) {
              this.files.push(element);
            }
          });
          this.files.push(...response.filter(file => file.type == 'Folder'));
        }
        else
          this.files = response;
        // Filter  by folder type in case the folder option is on
      }
      else
        this.files = response.filter(file => file.type == 'Folder')
      this.filesLoadingIndicator = false;

    }, err => {
      this.toastService.error("There is something wrong");
      this.filesLoadingIndicator = false;
    });
  }

  selectRows() {
    if (this.selectedRows.length > 0) {
      if (this.selectedRows[0].type == StorageTypeEnum.STORAGE) {
        this.files = [];
        if (this.allowMultipleSelection)
          this.selectionType = SelectionType.multiClick;
        this.isFilesMode = true;
        this.selectedStorage = this.selectedRows[0].storageId;
        this.selectedStorageName = this.selectedRows[0].filename;
        this.selectedRows = [];
        this.getAllFileStorage();


      }

      else if (this.selectedRows[0].type == StorageTypeEnum.LOCAL) {
        const uploader = this.fileInput.nativeElement as HTMLElement;
        uploader.click();
        this.selectedRows = [];
      }
      else if (this.selectedRows[0].type == StorageTypeEnum.TEMPLATES) {
        this.files = [];
        if (this.allowMultipleSelection)
          this.selectionType = SelectionType.multiClick;
        this.isFilesMode = true;
        this.selectedRows = []
        this.selectedStorage = 0;
        this.getAllFormTemplates();

      }
      else {
        // In Case MultiSlection
        if (this.allowMultipleSelection) {
          this.selectedRows.forEach(row => {
            // if select mutliple Selection and folder option is flase ------>  Select files only
            if (row.type == 'file' && !this.isFolderSelector) {
              this.addCloudObjectToOutputList(row);
            }
            // if select mutliple Selection  and folder option is closed ------>  Select folder only
            else if (row.type == 'Folder' && this.isFolderSelector) {
              this.addCloudObjectToOutputList(row);
            }
          });
          this.outputFiles.next(this.outputList);
          this.picked.emit([...this.outputList]);
          this.hide();
        }
        // Single Selection 
        else {
          // if select folder and folder option is false ----> open the folder
          if (this.selectedRows[0].type == 'Folder' && !this.isFolderSelector) {
            this.currentPath.push({ path: this.selectedRows[0].path, dirname: this.selectedRows[0].filename });
            if (this.selectedStorage > 0)
              this.getAllFileStorage();
            else
              this.getAllFormTemplates();
          }

          // Add single file in case folder option is false 
          else if (this.selectedRows[0].type == 'file' && !this.isFolderSelector) {
            this.addCloudObjectToOutputList(this.selectedRows[0]);
            this.outputFiles.next(this.outputList);
            this.picked.emit([...this.outputList]);
            this.hide();
          }

          // Add folder file in case folder option is true 
          else if (this.selectedRows[0].type == 'Folder' && this.isFolderSelector) {
            this.addCloudObjectToOutputList(this.selectedRows[0])
            this.outputFiles.next(this.outputList);
            this.picked.emit([...this.outputList]);
            this.hide();
          }
        }


      }
    } else if (this.isFolderSelector) {
      if (this.currentPath.length > 0) {
        this.addCloudObjectToOutputList({path: this.currentPath[this.currentPath.length - 1].path } as MyFile);
      } else {
        // need to select the top most directory
        this.addCloudObjectToOutputList({path: '/' } as MyFile);
      }
      
      this.outputFiles.next(this.outputList);
      this.picked.emit([...this.outputList]);
      this.hide();
    }
  }

  onErrLoadIcon(e: Event) {
    e.srcElement["src"] = "/assets/img/file-icons/unknown.png";
  }

  onactivate(event: any) {
    const row = <MyFile>event.row;

    if (event.type == "click") {
      // open folder on double click
      if (row.type === 'Folder') {
        this.selectedRows = [];
        this.currentPath.push({ path: row.path, dirname: row.filename });
        if (this.selectedStorage > 0)
          this.getAllFileStorage();
        else
          this.getAllFormTemplates();
      }
      // Double Click on file in case folder mode is off ---> select it
      else if (row.type === "file" && !this.isFolderSelector) {
        this.addCloudObjectToOutputList(row);
        this.outputFiles.next(this.outputList);
        this.picked.emit([...this.outputList]);
        this.hide();
      }
      else {
        this.selectedRows = [];
        this.selectedRows.push(row);
        this.selectRows();
      }
    }
  }
  // Open the parent folder of selected storage
  openRootFolder() {
    this.currentPath.splice(0);
    if (this.selectedStorage > 0)
      this.getAllFileStorage();
    else
      this.getAllFormTemplates();

  }

  // open specific folder from current path (my files > folder1 > folder2)
  openParentFolder(folder: FilePath) {
    const index = this.currentPath.findIndex(p => p.path == folder.path && p.dirname == folder.dirname);

    if (index > -1) {
      this.currentPath.splice(index + 1);
    }

    if (this.selectedStorage > 0)
      this.getAllFileStorage();
    else
      this.getAllFormTemplates();
  }

  // Perpare Object of type Cloud and send add it to output list
  addCloudObjectToOutputList(myFile: MyFile) {    
    if (this.selectedStorage == 0)  // templates
    {
      let formTemplate: TemplatePickedFile = {
        storageType: StorageTypeEnum.TEMPLATES,
        isFolder: this.isFolderSelector,
        path: myFile.path,
        id: myFile.id
      }
      this.outputList.push(formTemplate);
    }
    else
    {
      let cloudFile: CloudPickedFile = {
        storageType: StorageTypeEnum.STORAGE,
        isFolder: this.isFolderSelector,
        storageId: this.selectedStorage,
        path: myFile.path,
        storageName: this.selectedStorageName
      }
      this.outputList.push(cloudFile);
    }    
  }

  //#endregion

  //#region Template Region

  mapTemplateDataToFile(name: string, type: string, path: string, id?: number, extension?: string): MyFile {
    return {
      id: id,
      filename: name,
      extension: extension,
      type: type,
      size: 0,
      basename: "",
      dirname: "",
      formatted_size: "",
      icon: "",
      path: path,
      timestamp: 0
    };
  }


  getAllFormTemplates() {
    this.filesLoadingIndicator = true;
    let lastDir = '/';
    if (this.currentPath.length != 0) {
      lastDir = this.currentPath[this.currentPath.length - 1].path;
    }
    let filelist = [];
    this.formTemplateService.list(lastDir).subscribe((response: FormTemplate[]) => {
      response.forEach(element => {
        let path = element.path.split("/");
        let type = 'file';
        if (element.form_type_id == FormTemplateType.FOLDER)
          type = "Folder";
        if ((!this.isFolderSelector) || (this.isFolderSelector && type == "Folder"))
          filelist.push(this.mapTemplateDataToFile(path[path.length - 1], type, element.path, element.id, FormTemplateType[element.form_type_id].toString().toLowerCase()));
      });
      this.filesLoadingIndicator = false;
      this.files = filelist;

    }, err => {
      this.toastService.error("There is something wrong");
      this.filesLoadingIndicator = false;
    });
  }

  //#endregion
}
